import ncc1 from "../../../src/assets/images/ncc1.jpeg";
import ncc2 from "../../../src/assets/images/ncc2.jpeg";
import ncc3 from "../../../src/assets/images/ncc3.jpeg";
import ncc4 from "../../../src/assets/images/ncc4.jpeg";
import ncc5 from "../../../src/assets/images/ncc5.jpeg";
import ncc6 from "../../../src/assets/images/ncc6.jpeg";
import ncc7 from "../../../src/assets/images/ncc7.jpeg";
import ncc8 from "../../../src/assets/images/ncc8.jpeg";
import ncc9 from "../../../src/assets/images/ncc9.jpeg";
import ncc10 from "../../../src/assets/images/ncc10.jpeg";
import ncc11 from "../../../src/assets/images/ncc11.jpeg";
import ncc12 from "../../../src/assets/images/ncc12.jpeg";
import ncc13 from "../../../src/assets/images/ncc13.jpeg";

export const nccImageData = [
  { img: ncc1 },
  { img: ncc2 },
  { img: ncc3 },
  { img: ncc4 },
  { img: ncc5 },
  { img: ncc6 },
  { img: ncc7 },
  { img: ncc8 },
  { img: ncc9 },
  { img: ncc10 },
  { img: ncc11 },
  { img: ncc12 },
  { img: ncc13 },
];
